<template>
  <v-app :class="[$style.root, 'mb-5']">
    <div v-for="composition in compositions" :key="composition.id" class="mb-4">
      <ProductCompositionColor
        v-if="composition.id === 'color_decoracion'"
        :composition="composition"
        @updateOrder="onUpdateOrder"
      />

      <ProductComposition
        v-else
        :composition="composition"
        @updateOrder="onUpdateOrder"
      />
    </div>

    <TitleLine v-if="aditions.length > 0" title="Adiciones" />

    <ProductCompositionThumbs
      class="mt-3"
      :items="aditions"
      @updateOrder="onUpdateOrder"
    />

    <Minicart
      :class="[$style.rootMinicart]"
      :compositions="compositions"
      :order="order"
      @updateOrder="onUpdateOrder"
    />

    <input
      ref="inputDataBnCartOrder"
      type="hidden"
      name="bn_cart_order"
      :value="orderValue"
    />
  </v-app>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

// import store from '@/store'
import Product from '@/models/product.model'
import Composition from '@/models/composition.model'
import Order from '@/models/order.model'
import CompositionOrder from '@/models/compositionOrder.model'

import ProductComposition from 'Components/composite-product/CompositeProductComposition'
import ProductCompositionColor from 'Components/composite-product/CompositeProductCompositionColor'
import ProductCompositionThumbs from 'Components/composite-product/CompositeProductCompositionThumbs'
import Minicart from 'Components/composite-product/CompositeProductMinicart'

@Component({
  // store,
  components: {
    ProductComposition,
    ProductCompositionColor,
    ProductCompositionThumbs,
    Minicart,
  },
})
export default class WCCompositeProduct extends Vue {
  productId = 'bn_product'
  orderId = 'bn_order'

  dataParsed = null

  mounted() {
    this.dataParsed = JSON.parse(this.$dataProduct)
    console.log('this.dataParsed', this.dataParsed)

    this.setCompositions()

    Product.insert({
      data: {
        id: this.productId,
        name: 'BN PRODUCT',
        compositions: this.compositions,
        aditions: this.aditions,
      },
    })

    Order.insert({
      data: {
        id: this.productId,
        name: 'BN ORDER',
        baseCountItems: this._.get(this.dataParsed, 'base.length', 0),
        basePrice: this._.get(this.dataParsed, 'basePrice', 0),
        compositions: [],
        aditions: [],
      },
    })

    console.log('store', Product.query().first())
    console.log('order', this.order)
  }

  onUpdateOrder() {
    Order.update({
      id: this.productId,
      compositions: CompositionOrder.query().where('isAdition', false).get(),
      aditions: CompositionOrder.query().where('isAdition', true).get(),
    })

    console.log('Order', Order.query().first())
    // this.onUpdateInputData()
  }

  /* onUpdateInputData() {
    const input = this.$refs.inputDataBnCartOrder
    const formCart = document.querySelector('form.cart')

    formCart.append(input)
  } */

  get product() {
    return Product.find(this.productId)
  }

  get compositions() {
    return Composition.all().filter((item) => !item.isAdition)
  }

  get aditions() {
    const aditions = Composition.all().filter((item) => item.isAdition === true)
    let itemAdition = {
      id: 'aditions',
      options: aditions.map((item) => ({
        ...item,
      })),
    }

    console.log('get aditions', itemAdition)
    return aditions //[itemAdition]
  }

  get hasAditions() {
    return this._.get(this.aditions, 'options')
  }

  get order() {
    return Order.query().first()
  }

  get orderValue() {
    return JSON.stringify(this.order)
  }

  setCompositions() {
    this._.get(this.dataParsed, 'base', []).forEach((item) => {
      this._.map(item, (val, key) => {
        if (key !== 'acf_fc_layout') {
          Composition.insert({
            data: {
              id: key,
              name: key,
              options: val,
              isAdition: false,
            },
          })
        }
      })
    })

    if (
      this._.has(this.dataParsed, 'aditions') &&
      Array.isArray(this.dataParsed.aditions)
    ) {
      this.dataParsed.aditions.forEach((item) => {
        // this._.map(item, (val, key) => {
        // if (key !== 'acf_fc_layout' && val) {
        Composition.insert({
          data: {
            id: item.ID,
            name: item.post_title,
            data: item,
            isAdition: true,
          },
        })
        /* Composition.insert({
            data: {
              id: key + 2,
              name: key,
              options: val,
              isAdition: true,
            },
          })
          Composition.insert({
            data: {
              id: key + 3,
              name: key,
              options: val,
              isAdition: true,
            },
          })
          Composition.insert({
            data: {
              id: key + 4,
              name: key,
              options: val,
              isAdition: true,
            },
          }) */
        // }
        // })
      })
    }
  }
}
</script>

<style lang="scss">
@import url('https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.4/css/fontawesome.min.css');
// @import '~@fortawesome/fontawesome-free/scss/regular';
// @import '~@fortawesome/fontawesome-free/scss/brands';
// @import '~@fortawesome/fontawesome-free/scss/solid';

@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// @import '~vuetify/dist/vuetify.min.css';

// @import '~perfect-scrollbar/css/perfect-scrollbar.css';
@import '~vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
.ps-container {
  position: relative;
}

@import '~Assets/scss/main.scss';
</style>

<style lang="scss" module>
.root {
  &--Minicart {
  }
}
</style>
